var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"fab":""},on:{"click":function($event){return _vm.$emit('clicked')}}},'v-btn',_vm.btnAttrs,false),[_c('v-icon',[_vm._v(_vm._s(_vm.btnAttrs.iconClass))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }